module.exports = __webpack_public_path__ + "img/icon_heart_white.91959f1f.svg";